module.exports = __webpack_public_path__ + "img/civot.6275fd30.jpg";